/* eslint-disable import/prefer-default-export */
export const TASK_STATUS_V2 = {
  INIT: 'INIT', // 未开始
  RUNNING: 'RUNNING', // 进行中
  FINISHED: 'FINISHED', // 已结束
  UNFINISHED: 'UNFINISHED', // 过期未完成
  FORCE_STOP: 'FORCE_STOP', // FORCE_STOP
};

export const TaskStatus = {
  TO_ACCEPT: 0,
  DOING: 1,
  CAN_DONE: 2,
  DONE: 3,
  0: 0,
  1: 1,
  2: 2,
  3: 3,
};

// 任务领奖状态
// 0-任务进行中未领奖, 1-已完成未领奖(可领奖), 2-已完成已领奖
export const ActionStep = {
  DOING: 0,
  CAN_CLAIM: 1,
  CLAIMED: 2,
};
